module.exports = App.Views.Base.extend({
  el: '#user-icon',
  initialize: function() {
    var _this = this;
    // アイコンのfileuploadを設定
    $('#icon-image-upload-form').fileupload({
      dataType: 'json',
      url: '/api/image/user.json',
      formData: {"data[token]": App.me.token},
      dropZone: $('#user-icon'),
      pasteZone: null,
      submit:function() {
        _this.$('img').attr('src', App.ADMIN_IMAGE + 'loading.gif');
      },
      done: function (event, data) {
        var file_name = data.result.response;
        _this.$('img').attr('src', App.USER_IMAGE + file_name);
        $('#icon-image-name').val(file_name);
      },
      fail: function (event, data) {
        alert('ネットワークに問題があるようです。申し訳ありませんが、時間をおいて再度試してみてください。');
        _this.$("img").attr('src',  App.ADMIN_IMAGE + 'noprofileicon.png');
      },
      always: function() {
      }
    });
  },
});



// WEBPACK FOOTER //
// ./view/user.js